import { compose } from 'redux';
import { connect } from '../../../../../../common/react-redux';
import { screenreaderNotification } from '../../../../../../common/actions/alerts';
import { clearModifications, changeQuizInstructions } from '../../../../../../common/actions/modifications';
import { saveQuizChange } from '../../../../../api/quizzes';
import makeEditable from '../../../../../../common/components/shared/functionality/makeEditable';
import { featureOn } from '../../../../../../common/util/featureCheck';
import Instructions from './presenter';
function mapStateToProps(state) {
  return {
    errorsShowing: state.get('errorsShowing'),
    lockBlueprintContentEnabled: featureOn('lock_blueprint_content')
  };
}
var mapDispatchToProps = {
  changeQuizInstructions: changeQuizInstructions,
  clearModifications: clearModifications,
  saveQuizChange: saveQuizChange,
  screenreaderNotification: screenreaderNotification
};
export var QuizInstructions = compose(makeEditable, connect(mapStateToProps, mapDispatchToProps))(Instructions);
export default QuizInstructions;